import React from 'react';
import WpHelpApp from './WpHelpApp'; // Import the main application component

const App = () => {
  return (
    <div className="App">
  
      <WpHelpApp />  {/* Render the main application component */}
    </div>
  );
};

export default App;
